/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivDocumentPublicControllerCreatePublicPayloadGen,
  MrfiktivDocumentViewModelGen,
  MrfiktivExceptionViewmodelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DocumentPublic<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Document (Public)
   * @name DocumentPublicControllerCreatePublic
   * @summary Anonymously upload a document for a partner
   * @request POST:/partner/{partnerId}/document/public
   * @response `200` `MrfiktivDocumentViewModelGen` The created document
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  documentPublicControllerCreatePublic = (
    partnerId: string,
    data: MrfiktivDocumentPublicControllerCreatePublicPayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/document/public`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
}
